import { ActiveTourDetailModel, ActiveTourModel, CustomsDetails, DashboardModel, MyToursClient } from './../../core/services/api.service';
import { State, Selector, Store, Action, StateContext } from '@ngxs/store';
import { NotesClient, NotesModel, PagedListingResponseOfTourListHistoryModel, TourClient, TourHistoryModel, TourModel, TourVehicleRouteModel } from '@core/services/api.service';
import { Injectable } from '@angular/core';
import { SignalRService } from '@core/services/signalr.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { AddSelectedActiveTourIdAction, AddSelectedActiveTourIdsAction, ClearActiveToursAction, LoadActiveTourListAction, LoadActiveTourListFailAction, LoadActiveTourListSuccessAction, LoadAllActiveToursListAction, LoadAllActiveToursListFailAction, LoadAllActiveToursListSuccessAction, LoadMyCustomsDashboardAction, LoadMyCustomsDashboardFailAction, LoadMyCustomsDashboardSuccessAction, LoadMyCustomsHistoryListAction, LoadMyCustomsHistoryListFailAction, LoadMyCustomsHistoryListSuccessAction, LoadMyCustomsListAction, LoadMyCustomsListFailAction, LoadMyCustomsListSuccessAction, LoadMyTourHistoryListAction, LoadMyTourHistoryListFailAction, LoadMyTourHistoryListSuccessAction, LoadMyTourListAction, LoadMyTourListDetailsAction, LoadMyTourListDetailsFailAction, LoadMyTourListDetailsSuccessAction, LoadMyTourListFailAction, LoadMyTourListSuccessAction, RemoveAllSelectedActiveTourIdAction, RemoveSelectedActiveTourIdAction } from './my-tours.action';

export class MyToursStateModel {
    public isLoading: boolean;
    public tourList: TourModel[];
    public filteredTourList: TourModel[];
    public selectedCategory: string;
    public selectedDepartments: number[];
    public selectedTypes: number[];
    public signalRHandlersRegistered: boolean;
    public tourHistory: TourHistoryModel[];
    public tourHistoryList: PagedListingResponseOfTourListHistoryModel;
    public tourUpdateHistory: TourHistoryModel[];
    public selectedTour: TourModel;
    public notes: NotesModel[];
    public route: TourVehicleRouteModel;
    public activeTourList: ActiveTourModel[];
    public activeTourListDetails: ActiveTourDetailModel[];
    public allActiveTourListDetails: ActiveTourDetailModel[];
    public selectedTourIds: number[];
    public myCustomsList: CustomsDetails[];
    public myCustomsDashboard: DashboardModel[];
    public myCustomsHistory: TourHistoryModel[];
    public myCustomsHistoryList: PagedListingResponseOfTourListHistoryModel;
}

@State<MyToursStateModel>({
    name: 'MyTours',
    defaults: {
        isLoading: true,
        tourList: [],
        filteredTourList: [],
        selectedCategory: '',
        selectedDepartments: [],
        selectedTypes: [],
        signalRHandlersRegistered: false,
        tourHistory: [],
        tourHistoryList: null,
        tourUpdateHistory: [],
        selectedTour: null,
        notes: [],
        route: null,
        activeTourList: [],
        activeTourListDetails: [],
        allActiveTourListDetails: [],
        selectedTourIds:JSON.parse(localStorage.getItem('MyTours.selectedTourIds') || '[]'),
        myCustomsList: [],
        myCustomsDashboard: [],
        myCustomsHistory: [],
        myCustomsHistoryList: null
    }
})
@Injectable()
export class MyToursState {
    constructor(private myTourServive: MyToursClient, public signalRService: SignalRService) { }
    @Selector()
    static getIsLoading(state: MyToursStateModel) {
        return state.isLoading;
    }
    @Selector()
    static getSelectedToursId(state: MyToursStateModel) {
        return state.selectedTourIds;
    }

    @Selector()
    static getActiveTours(state: MyToursStateModel) {
        return state.activeTourList;
    }

    @Selector()
    static getActiveTourDetails(state: MyToursStateModel) {
        return state.activeTourListDetails;
    }

    @Selector()
    static getAllActiveToursDetails(state: MyToursStateModel) {
        return state.allActiveTourListDetails;
    }

    @Selector()
    static getMyFilteredTours(state: MyToursStateModel) {
        return state.tourList;
    }

    @Selector()
    static getMyTourHistoryList(state: MyToursStateModel) {
        return state.tourHistoryList;
    }

    @Selector()
    static getMyTourHistory(state: MyToursStateModel) {
        return state.tourHistory;
    }

    @Selector()
    static getMyCustomsList(state: MyToursStateModel) {
        return state.myCustomsList;
    }

    @Selector()
    static getMyCustomsDashboard(state: MyToursStateModel) {
        return state.myCustomsDashboard;
    }

    @Selector()
    static getMyCustomsHistory(state: MyToursStateModel) {
        return state.myCustomsHistory;
    }

    @Selector()
    static getMyCustomsHistoryList(state: MyToursStateModel) {
        return state.myCustomsHistoryList;
    }

    @Action(LoadMyTourListFailAction)
    loadMyTourListFailAction(ctx: StateContext<MyToursStateModel>, action: LoadMyTourListFailAction) {
        ctx.patchState({
            isLoading: false,
            tourList: []
        });
    }


    @Action(LoadMyTourListAction)
    loadMyTourListAction({ dispatch, patchState }: StateContext<MyToursStateModel>, action: LoadMyTourListAction) {
        patchState({ isLoading: true });

        return this.myTourServive.getMyTourList().pipe(
            tap((tours) => dispatch(new LoadMyTourListSuccessAction({ tours }))),
            catchError((err) => dispatch(new LoadMyTourListFailAction()))
        );
    }

    @Action(LoadMyTourListSuccessAction)
    loadMyTourListSuccessAction({ dispatch, patchState }: StateContext<MyToursStateModel>, action: LoadMyTourListSuccessAction) {
        patchState({
            isLoading: false,
            tourList: action.payload.tours
        });
    }

    @Action(LoadMyTourHistoryListAction)
    loadMyTourHistoryListAction({ dispatch, patchState }: StateContext<MyToursStateModel>, action: LoadMyTourHistoryListAction) {
        patchState({ isLoading: true });
        localStorage.setItem('MyTourHistoryQuery', JSON.stringify(action.payload.GetMyTourHistoryQuery));

        return this.myTourServive.getMyTourHistory(action.payload.GetMyTourHistoryQuery).pipe(
            tap((tourHistoryList) => dispatch(new LoadMyTourHistoryListSuccessAction({ tourHistoryList }))),
            catchError((err) => dispatch(new LoadMyTourHistoryListFailAction()))
        );
    }

    @Action(LoadMyTourHistoryListSuccessAction)
    loadMyTourHistoryListSuccessAction(ctx: StateContext<MyToursStateModel>, action: LoadMyTourHistoryListSuccessAction) {
        ctx.patchState({
            isLoading: false,
            tourHistory: action.payload.tourHistoryList.results,
            tourHistoryList: action.payload.tourHistoryList
        });
    }

    @Action(LoadMyTourHistoryListFailAction)
    loadMyTourHistoryListFailAction(ctx: StateContext<MyToursStateModel>, action: LoadMyTourHistoryListFailAction) {
        ctx.patchState({
            isLoading: false,
            tourHistory: [],
            tourHistoryList: null
        });
    }

    @Action(LoadActiveTourListAction)
    LoadActiveTourListAction({ dispatch, patchState }: StateContext<MyToursStateModel>, action: LoadActiveTourListAction) {
        patchState({ isLoading: true });

        return this.myTourServive.getActiveTours().pipe(
            tap((tours) => dispatch(new LoadActiveTourListSuccessAction({ tours }))),
            catchError((err) => dispatch(new LoadActiveTourListFailAction()))
        );
    }

    @Action(LoadActiveTourListSuccessAction)
    LoadActiveTourListSuccessAction(ctx: StateContext<MyToursStateModel>, action: LoadActiveTourListSuccessAction) {
        ctx.patchState({
            isLoading: false,
            activeTourList: action.payload.tours,
        });
    }

    @Action(LoadActiveTourListFailAction)
    LoadActiveTourListFailAction(ctx: StateContext<MyToursStateModel>, action: LoadActiveTourListFailAction) {
        ctx.patchState({
            isLoading: false,
            activeTourList: [],
        });
    }

    @Action(LoadMyTourListDetailsAction)
    LoadMyTourListDetailsAction({ dispatch, patchState, getState }: StateContext<MyToursStateModel>, action: LoadMyTourListDetailsAction) {
        patchState({ isLoading: true });

        const state = getState();
        const tourListDetails = state.activeTourListDetails;

        return this.myTourServive.getActiveTourDetails(action.payload.GetActiveTourDetailsQuery).pipe(
            tap((activeTourDetails) => {
                const existingIndex = tourListDetails.findIndex(tour => tour.id === activeTourDetails.id);
                if (existingIndex !== -1) {
                    const updatedTourListDetails = [
                        ...tourListDetails.slice(0, existingIndex),
                        ...tourListDetails.slice(existingIndex + 1)
                    ];
                    patchState({
                        isLoading: false,
                        activeTourListDetails: updatedTourListDetails
                    });
                } else {
                    patchState({
                        isLoading: false,
                        activeTourListDetails: [...tourListDetails, activeTourDetails]
                    });
                }
            }),
            catchError((err) => dispatch(new LoadMyTourListDetailsFailAction()))
        );
    }

    @Action(LoadMyTourListDetailsSuccessAction)
    LoadMyTourListDetailsSuccessAction({ dispatch, getState, patchState }: StateContext<MyToursStateModel>, action: LoadMyTourListDetailsSuccessAction) {
        const state = getState();
        patchState({
            isLoading: false,
            activeTourListDetails: state.activeTourListDetails.findIndex((v) => v.id === action.payload.activeTourDetails.id) > -1
            ? state.activeTourListDetails.map((tourDetails) => (tourDetails.id === action.payload.activeTourDetails.id ? action.payload.activeTourDetails : tourDetails))
            : [...state.activeTourListDetails, action.payload.activeTourDetails]
        });
    }

    @Action(LoadMyTourListDetailsFailAction)
    LoadMyTourListDetailsFailAction(ctx: StateContext<MyToursStateModel>, action: LoadMyTourListDetailsFailAction) {
        ctx.patchState({
            isLoading: false,
            activeTourList: [],
        });
    }


    @Action(LoadAllActiveToursListAction)
    LoadAllActiveToursListAction({ dispatch, patchState }: StateContext<MyToursStateModel>, action: LoadAllActiveToursListAction) {
        patchState({ isLoading: true });



        return this.myTourServive.getAllActiveTourDetails(action.payload.GetAllActiveTourDetailsQuery).pipe(
        tap((allActiveTourDetails: ActiveTourDetailModel[]) => dispatch(new LoadAllActiveToursListSuccessAction({allActiveTourDetails}))),
        catchError((error) => dispatch(new LoadAllActiveToursListFailAction()))
        );
    }

    @Action(ClearActiveToursAction)
    ClearActiveToursAction({ dispatch, patchState }: StateContext<MyToursStateModel>, action: ClearActiveToursAction) {
        patchState({ isLoading: true, allActiveTourListDetails: [], activeTourListDetails: [] });
    }

    @Action(LoadAllActiveToursListSuccessAction)
    LoadAllActiveToursListSuccessAction({ patchState }: StateContext<MyToursStateModel>, action: LoadAllActiveToursListSuccessAction) {
        patchState({
        isLoading: false,
        allActiveTourListDetails: action.payload.allActiveTourDetails,
        });
    }

    @Action(LoadAllActiveToursListFailAction)
    LoadAllActiveToursListFailAction({ patchState }: StateContext<MyToursStateModel>, action: LoadAllActiveToursListFailAction) {
        patchState({
        isLoading: false,
        activeTourListDetails: [],
        });
    }
      // Action to add tourId
  @Action(AddSelectedActiveTourIdAction)
  addSelectedActiveTourId(ctx: StateContext<MyToursStateModel>, action: AddSelectedActiveTourIdAction) {
    const state = ctx.getState();
    ctx.patchState({
      selectedTourIds: [...state.selectedTourIds, action.payload.Id]
    });
  }

  // Action to remove tourId
  @Action(RemoveSelectedActiveTourIdAction)
  removeSelectedActiveTourId(ctx: StateContext<MyToursStateModel>, action: RemoveSelectedActiveTourIdAction) {
    const state = ctx.getState();
    var selected=state.selectedTourIds.filter(id => id !== action.payload.Id)
    ctx.patchState({
      selectedTourIds: selected
    });
  }
  @Action(AddSelectedActiveTourIdsAction)
  addSelectedActiveTourIdsAction(ctx: StateContext<MyToursStateModel>, action: AddSelectedActiveTourIdsAction) {
    const state = ctx.getState();
    ctx.patchState({
      selectedTourIds:action.payload.Ids
    });
  }
  @Action(RemoveAllSelectedActiveTourIdAction)
  removeAllSelectedActiveTourId({ dispatch, patchState }: StateContext<MyToursStateModel>, action: RemoveAllSelectedActiveTourIdAction) {
    
    patchState({
      selectedTourIds:[]
    });
  }

  @Action(LoadMyCustomsListAction)
  loadMyCustomsListAction({ dispatch, patchState }: StateContext<MyToursStateModel>) {
    patchState({ isLoading: true });

    return this.myTourServive.getMyCustomsList().pipe(
      tap((customsList) => dispatch(new LoadMyCustomsListSuccessAction({ customsList }))),
      catchError(() => dispatch(new LoadMyCustomsListFailAction()))
    );
  }

  @Action(LoadMyCustomsListSuccessAction)
  loadMyCustomsListSuccessAction(ctx: StateContext<MyToursStateModel>, action: LoadMyCustomsListSuccessAction) {
    ctx.patchState({
      isLoading: false,
      myCustomsList: action.payload.customsList ?? []
    });
  }

  @Action(LoadMyCustomsListFailAction)
  loadMyCustomsListFailAction(ctx: StateContext<MyToursStateModel>) {
    ctx.patchState({
      isLoading: false,
      myCustomsList: []
    });
  }

  @Action(LoadMyCustomsDashboardAction)
  loadMyCustomsDashboardAction({ dispatch, patchState }: StateContext<MyToursStateModel>) {
    patchState({ isLoading: true });

    return this.myTourServive.getMyCustomsDashboard().pipe(
      tap((dashboards) => dispatch(new LoadMyCustomsDashboardSuccessAction({ dashboards }))),
      catchError(() => dispatch(new LoadMyCustomsDashboardFailAction()))
    );
  }

  @Action(LoadMyCustomsDashboardSuccessAction)
  loadMyCustomsDashboardSuccessAction(ctx: StateContext<MyToursStateModel>, action: LoadMyCustomsDashboardSuccessAction) {
    ctx.patchState({
      isLoading: false,
      myCustomsDashboard: action.payload.dashboards ?? []
    });
  }

  @Action(LoadMyCustomsDashboardFailAction)
  loadMyCustomsDashboardFailAction(ctx: StateContext<MyToursStateModel>) {
    ctx.patchState({
      isLoading: false,
      myCustomsDashboard: []
    });
  }

  @Action(LoadMyCustomsHistoryListAction)
  loadMyCustomsHistoryListAction({ dispatch, patchState }: StateContext<MyToursStateModel>, action: LoadMyCustomsHistoryListAction) {
    patchState({ isLoading: true });
    localStorage.setItem('MyCustomsHistoryQuery', JSON.stringify(action.payload.GetMyCustomsHistoryQuery));

    return this.myTourServive.getMyCustomsHistory(action.payload.GetMyCustomsHistoryQuery).pipe(
      tap((customsHistoryList) => dispatch(new LoadMyCustomsHistoryListSuccessAction({ customsHistoryList }))),
      catchError(() => dispatch(new LoadMyCustomsHistoryListFailAction()))
    );
  }

  @Action(LoadMyCustomsHistoryListSuccessAction)
  loadMyCustomsHistoryListSuccessAction(ctx: StateContext<MyToursStateModel>, action: LoadMyCustomsHistoryListSuccessAction) {
    ctx.patchState({
      isLoading: false,
      myCustomsHistory: action.payload.customsHistoryList?.results ?? [],
      myCustomsHistoryList: action.payload.customsHistoryList ?? null
    });
  }

  @Action(LoadMyCustomsHistoryListFailAction)
  loadMyCustomsHistoryListFailAction(ctx: StateContext<MyToursStateModel>) {
    ctx.patchState({
      isLoading: false,
      myCustomsHistory: [],
      myCustomsHistoryList: null
    });
  }
}
